/* eslint-disable react/jsx-no-literals */
import React from 'react';
import Typography from 'carbon-react/lib/components/typography';
import Icon from 'carbon-react/lib/components/icon';
import { defineMessages, useIntl } from 'react-intl';

import styles from './insight-recommendation.scss';

type RecommendationClassification = 'opportunity' | 'risk';

export interface InsightRecommendationProps {
  classification: RecommendationClassification;
  text: string;
}

const classificationMessages = defineMessages({
  opportunity: { id: 'aiInsights.classification.opportunity', defaultMessage: 'Opportunity' },
  risk: { id: 'aiInsights.classification.risk', defaultMessage: 'Risk' }
});

const CLASSIFICATION_CONFIG: Record<
  RecommendationClassification,
  { color: string; icon: 'lightbulb_on' | 'warning'; recommendationClass: string }
> = {
  opportunity: {
    color: '#0071C3',
    icon: 'lightbulb_on',
    recommendationClass: styles.recommendationOpportunity
  },
  risk: {
    color: '#D64309',
    icon: 'warning',
    recommendationClass: styles.recommendationRisk
  }
};

export const InsightRecommendation = ({ classification, text }: InsightRecommendationProps) => {
  const intl = useIntl();
  const classificationConfig = CLASSIFICATION_CONFIG[classification];

  return (
    <div className={`${styles.recommendation} ${classificationConfig.recommendationClass}`}>
      <div className={styles.recommendationBody}>
        <span className={styles.classificationIcon}>
          <Icon type={classificationConfig.icon} color={classificationConfig.color} />
        </span>
        <div className={styles.recommendationContent}>
          <Typography fontSize="14px" fontWeight="500" lineHeight="150%" mb={0} className={styles.recommendationTitle}>
            {intl.formatMessage(classificationMessages[classification])}
          </Typography>
          <Typography fontSize="14px" fontWeight="400" lineHeight="150%" mb={0} className={styles.recommendationText}>
            {text}
          </Typography>
        </div>
      </div>
    </div>
  );
};
